export const HTTPService = fetch;